import Axios from "axios";

const state = {
  templates: [],
  templatesLoaded: false
};

const getters = {
  getTemplateByKey: state => key => {
    return window._.find(state.templates, t => {
      return t.key === key;
    });
  },
  getTemplateById: state => id => {
    return window._.find(state.templates, t => {
      return t.id === id;
    });
  },
  templatesLoaded: state => state.templatesLoaded
};

const actions = {
  /**
   * @description Load templates from API
   *
   * @param {*} { commit }
   */
  loadTemplates({ commit }) {
    //eslint-disable-next-line
    let url = CONF.apiUrl;
    Axios.get(url + "templates")
      .then(r => {
        commit("setTemplates", r.data.templates);
      })
      .catch(e => window.console.error(e));
  }
};

const mutations = {
  /**
   * @description Set templates to store
   *
   * @param {*} state
   * @param {*} payload
   */
  setTemplates(state, payload) {
    state.templates = payload;
    state.templatesLoaded = true;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
